import { render, staticRenderFns } from "./PoliceIntegrateManager.vue?vue&type=template&id=627c01d0&"
import script from "./PoliceIntegrateManager.vue?vue&type=script&lang=js&"
export * from "./PoliceIntegrateManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports